import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotArticles from './components/HotArticles';
import LatestNews from './components/LatestNews';
import FAQSection from './components/FAQSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '澳门彩官方指南',
    url: 'https://lotterytip.github.io',
    description: '澳门彩官方指南为您提供最全面的澳门彩资讯服务，涵盖玩法规则、开奖结果、购买技巧与中奖攻略。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://lotterytip.github.io/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '澳门彩官方指南·玩法规则全解析',
    description: '澳门彩官方指南为您提供最全面的澳门彩资讯服务，涵盖澳门彩玩法规则详解、最新开奖结果查询、专业购买技巧分享、高效中奖攻略指导。',
    url: 'https://lotterytip.github.io/',
    isPartOf: {
      '@type': 'WebSite',
      name: '澳门彩官方指南',
      url: 'https://lotterytip.github.io',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <HotArticles />
          <LatestNews />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}